import { render, staticRenderFns } from "./request-expand.vue?vue&type=template&id=04a85d20&scoped=true&"
import script from "./request-expand.vue?vue&type=script&lang=js&"
export * from "./request-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a85d20",
  null
  
)

export default component.exports